<template>
  <div class="Home">
    <!-- carouse info -->
    <div class="Bglogo">
      <el-carousel trigger="click" height="330px">
        <el-carousel-item v-for="(item, index) in carouselList" :key="index">
          <img :src="item.src" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- login info -->
    <div class="loginInfo">
      <div class="BOX">
        <div class="Content">
          <el-card class="box-card">
            <div class="loginBox">
              <div class="left">
                <img src="@/assets/images/Home/user.png" />
                <span class="userInfo" v-if="token">{{ name }}</span>
                <span class="userInfo" v-else @click="handleToLogin">登 录</span>
              </div>
              <div class="right">欢 迎 访 问 斯 坦 德 检 测 积 分 商 城</div>
            </div>
            <div class="userInfoBox">
              <div class="top">
                <div class="chuck double">
                  <div v-if="token">{{ info.availableIntegral }}</div>
                  <div v-else>0</div>
                  <div>我的积分</div>
                </div>
                <div class="chuck double">
                  <div v-if="token">{{ info.pendingIntegral }}</div>
                  <div v-else>0</div>
                  <div>待到账积分</div>
                </div>
                <div class="chuck double">
                  <div v-if="token">{{ info.freezeIntegral }}</div>
                  <div v-else>0</div>
                  <div>失效积分</div>
                </div>
                <div class="chuck Link" style="cursor: auto;">赚取积分</div>
              </div>
              <div class="bottom">
                <div class="chuck Link" @click="handleToINTEGRALRULE">积分规则</div>
                <div class="chuck Link" @click="handleToReturnGoodsPolicy">退换货政策</div>
                <div class="chuck Link" @click="handleToBulletin">商城公告</div>
                <div class="chuck Link" @click="handleToMyOrders">我的订单</div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- Goods info -->
    <div class="GoodsList">
      <div class="filteren">
        <span class="title">顺序筛选：</span>
        <div class="condition">
          <div class="condition_Icon">
            <i class="el-icon-caret-top" :style="{ color: GoodsForm.isAsc === '0' ? '#61acf9': '#2c3e50' }" @click="handleAscendingOrder('0')"></i>
            <i class="el-icon-caret-bottom" :style="{ color: GoodsForm.isAsc === '1' ? '#61acf9': '#2c3e50' }" @click="handleAscendingOrder('1')"></i>
          </div>
          <span>积分高低</span>
        </div>
        <div class="condition" style="margin-left: 16px;">
          <div class="condition_Icon">
            <i class="el-icon-caret-top" :style="{ color: GoodsForm.type === '0' ? '#61acf9': '#2c3e50' }" @click="handleChangeTheNumber('0')"></i>
            <i class="el-icon-caret-bottom" :style="{ color: GoodsForm.type === '1' ? '#61acf9': '#2c3e50' }" @click="handleChangeTheNumber('1')"></i>
          </div>
          <span>兑换数量</span>
        </div>
      </div>
      <div class="GoodsBox" v-loading="listLoading">
        <div v-if="GoodsList.length > 0">
          <el-card shadow="never" :body-style="{ padding: '0px' }" v-for="(item, index) in GoodsList" :key="index">
            <div class="integralModel">{{ item.integral }} 积分</div>
            <img :src="item.mainAttachments ? item.mainAttachments.httpPath : ''" class="image">
            <div class="describe">
              <p>{{ item.commodityName }}</p>
              <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                <p>{{ item.commodityDesc }}</p>
              </el-tooltip>
            </div>
            <div class="btn">
              <el-button size="mini" type="primary" @click="handleImmediatelyChange(item)" plain>立 即 兑 换</el-button>
            </div>
          </el-card>
        </div>
        <div class="GoodsBox_No" v-else>暂无数据</div>
      </div>
      <!-- tip -->
      <!-- <div class="tip" v-if="GoodsList.length > 0">*温馨提示：同一账号同一产品，一个月内只能兑换一件。另外，本积分商城暂不提供港澳台及海外地区的积分兑换服务，敬请见谅。</div> -->
      <!-- page -->
      <div class="page">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="GoodsForm.currentPage"
          background
          :page-size="GoodsForm.pageSize"
          layout="total, prev, pager, next, jumper"
          prev-text="上一页"
          next-text="下一页"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 登录 -->
    <LoginDialog ref="LoginDialog" />

    <!-- 商城公告 -->
    <Notice ref="Notice" />
  </div>
</template>

<script>
import * as API from '@/api/user';
import LoginDialog from "./components/Login";
import Notice from "@/views/components/Notice";
import { mapGetters } from 'vuex';
import { getCommonToken } from '@/utils/auth';
export default {
  name: 'Home',
  components: {
    LoginDialog,
    Notice
  },
  computed: {
    ...mapGetters(['name', 'token', 'info']),
    time() {
      if(this.$route.query.time) {
        return this.$route.query.time;
      } else {
        return '';
      }
    }
  },
  watch: {
    time() {
      if(this.$route.query.commodityName) {
        this.$set(this.GoodsForm, 'commodityName', this.$route.query.commodityName);
      } else {
        this.$set(this.GoodsForm, 'commodityName', '');
      }
      this.GetList();
    }
  },
  data() {
    return {
      // 轮播图
      carouselList: [
        { src: `./Home/carousel1.jpg` }, { src: `./Home/carousel2.jpg` }, { src: `./Home/carousel3.jpg` }
      ],
      // 货品数据
      GoodsList: [],
      GoodsForm: {
        // 当前页
        currentPage: 1,
        pageSize: 20,
        type: '0',
        isAsc: '0',
        commodityName: ''
      },
      // 总页数
      total: 0,
      listLoading: false
    }
  },
  methods: {
    // 0 升序  1 降序
    handleAscendingOrder(isAsc) {
      this.GoodsForm.isAsc = isAsc;
      this.GetList();
    },
    // // 0 积分 1 兑换数量
    handleChangeTheNumber(type) {
      this.GoodsForm.type = type;
      this.GetList();
    },
    // 登录
    handleToLogin() {
      this.$refs.LoginDialog.open();
    },
    // 积分规则
    handleToINTEGRALRULE() {
      if(this.token) {
        let url = this.$router.resolve({ path: '/IntegrationRule' });
        window.open(url.href, '_blank');
      } else {
        this.$message({ type: "error", message: "请登录用户" });
      }
    },
    // 退换货政策
    handleToReturnGoodsPolicy() {
      if(this.token) {
        let url = this.$router.resolve({ path: '/IntegrationRule' });
        window.open(url.href, '_blank');
      } else {
        this.$message({ type: "error", message: "请登录用户" });
      }
    },
    // 商城公告
    handleToBulletin() {
      if(this.token) {
        this.$refs.Notice.open();
      } else {
        this.$message({ type: "error", message: "请登录用户" });
      }
    },
    // 我的订单
    handleToMyOrders() {
      if(this.token) {
        this.$router.push({ path: '/MyOrder' });
      } else {
        this.$message({ type: "error", message: "请登录用户" });
      }
    },
    // 立即兑换
    handleImmediatelyChange(item) {
      if(this.token) {
        this.$router.push({ path: '/Product', query: { id: item.id } });
      } else {
        this.$message({ type: "error", message: "请登录用户" });
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.GoodsForm.currentPage = val;
      this.GetList();
    },
    // 首页商品列表
    GetList() {
      let params = this.GoodsForm;
      if (getCommonToken("MOBILE")) {
        params.xdkh = getCommonToken("MOBILE");
      } else {
        params.xdkh = "";
      }
      this.listLoading = true;
      API.getCommodityInfoList(params).then(res => {
        this.listLoading = false;
        if(res.code === 20000) {
          this.GoodsList = res.data.items;
          this.total = res.data.total;
        }
      }).catch(err => {
        console.log(err);
        this.listLoading = false;
      });
    }
  },
  mounted() {
    if(this.$route.query.commodityName) {
      this.$set(this.GoodsForm, 'commodityName', this.$route.query.commodityName);
      this.GetList();
    } else {
      this.GetList();
    }
  }
}
</script>

<style scoped>
.Home {
  position: relative;
}
.Home .Bglogo {
  height: 330px;
  min-width: 1440px;
}
.Home .Bglogo /deep/ .el-carousel__item img {
  width: 100%;
  height: 330px;
  vertical-align: middle;
}
.Home .Bglogo /deep/ .el-carousel__indicators--horizontal {
  top: 6%;
  left: 90%;
  transform: translateX(-50%);
}
.Home .loginInfo {
  height: 400px;
  position: relative;
}
.Home .loginInfo .BOX {
  width: 1280px;
  margin: 0 auto;
}
.Home .loginInfo .Content {
  width: 900px;
  position: absolute;
  top: -50px;
  left: 50%;
  margin-left: -450px;
  z-index: 10;
}
.Home .loginInfo .Content /deep/ .el-card.is-always-shadow {
  box-shadow: 0 10px 30px 0 rgba(0,0,0,.32);
}
.Home .loginInfo .Content /deep/ .el-card {
  border-radius: 28px;
  color: #000;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body {
  height: 310px;
  overflow: auto;
  padding: 30px 50px;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .loginBox {
  overflow: hidden;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .userInfoBox {
  margin-top: 20px;
  border: 1px solid #000000;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .userInfoBox .top {
  border-bottom: 1px solid #000000;
  overflow: hidden;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .userInfoBox .bottom {
  overflow: hidden;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .chuck {
  border-right: 1px solid #000000;
  width: 168px;
  height: 80px;
  padding: 15px;
  float: left;
  line-height: 80px;
  font-size: 22px
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .chuck.double {
  line-height: 36px;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .chuck.Link {
  cursor: pointer;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .userInfoBox .top .chuck:last-child,
.Home .loginInfo .Content /deep/ .el-card .el-card__body .userInfoBox .bottom .chuck:last-child {
  border-right: 0;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .loginBox .left {
  float: left;
  overflow: hidden;
  cursor: pointer;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .loginBox img {
  vertical-align: middle;
  margin-right: 16px;
  float: left;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .loginBox .userInfo {
  font-size: 28px;
  float: left;
  margin-top: 10px;
}
.Home .loginInfo .Content /deep/ .el-card .el-card__body .loginBox .right {
  float: right;
  margin-top: 20px;
  color: #868686;
  font-size: 16px;
}
.Home .GoodsList {
  width: 1280px;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 200px;
}
.Home .GoodsList .filteren {
  text-align: right;
  padding-bottom: 12px;
  border-bottom: 1px solid;
  margin-top: 40px;
  margin-bottom: 30px;
}
.Home .GoodsList .filteren .title {
  font-size: 14px;
}
.Home .GoodsList .filteren .condition {
  font-weight: 600;
  font-size: 15px;
  display: inline-block;
  cursor: pointer;
}
.Home .GoodsList .filteren .condition_Icon {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
}
.Home .GoodsList .filteren .condition_Icon i {
  position: absolute;
  left: 0;
}
.Home .GoodsList .filteren .condition_Icon .el-icon-caret-to {
  top: -4px;
}
.Home .GoodsList .filteren .condition_Icon .el-icon-caret-bottom {
  bottom: -6px;
}
.Home .GoodsList .GoodsBox {
  overflow: hidden;
  min-height: 666px;
}
.Home .GoodsList .GoodsBox .GoodsBox_No {
  height: 666px;
  line-height: 666px;
  color: #9c9c9c;
}
.Home .GoodsList .GoodsBox /deep/ .el-card {
  float: left;
  width: 222px;
  margin-top: 30px;
  border-radius: 10px;
  border-color: #c6c7ca;
  margin-right: 40px;
  position: relative;
}
.Home .GoodsList .GoodsBox /deep/ .el-card .integralModel {
  position: absolute;
  right: 0;
  top: 200px;
  line-height: 24px;
  background: #3880ca;
  font-size: 14px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  padding: 0 6px 0 16px;
  color: #ffffff;
}
.Home .GoodsList .GoodsBox /deep/ .el-card:nth-child(5n) {
  margin-right: 0;
}
.Home .GoodsList .GoodsBox /deep/ .el-card img {
  height: 240px;
  width: 100%;
  vertical-align: middle;
}
.Home .GoodsList .GoodsBox /deep/ .el-card .describe {
  overflow: hidden;
  margin: 10px 20px 0;
  padding-bottom: 20px;
  border-bottom: 1px solid #c6c7ca;
}
.Home .GoodsList .GoodsBox /deep/ .el-card .describe p {
  width: 100%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.Home .GoodsList .GoodsBox /deep/ .el-card p {
  margin-bottom: 0;
  margin-top: 10px;
}
.Home .GoodsList .GoodsBox /deep/ .el-card .btn {
  padding: 12px 20px;
}
.Home .GoodsList .GoodsBox /deep/ .el-card .btn .el-button {
  width: 100%;
  /* border-color: #c6e2ff;
  color: #409EFF; */
  /* background-color: #ecf5ff; */
  border-radius: 5px;
}
.Home .GoodsList .tip {
  font-size: 14px;
  text-align: center;
  color: #9c9c9c;
  margin-top: 20px;
}
.Home .GoodsList .page {
  margin-top: 120px;
}
.Home .GoodsList .page /deep/ .el-pagination.is-background .btn-next, 
.Home .GoodsList .page /deep/ .el-pagination.is-background .btn-prev {
  padding: 0 5px;
}
</style>
